<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<div class="bodyMain-wrap width-100">
    <div class="px-0 dashboard-mainContainer">
        <div class="row">
            <div class="col-md-12 welcome-wrapper pe-5">
                <h1>Hi Admin {{name1}} {{name2}}</h1>
            </div>
        </div>
        <div class="row mainContainer">
            <div class="dashboardBox-wrapper widthAdjust40">
                <div class="whiteBg_container">
                    <!-- <div class="d-flex flex-between">
              <span><img src="images/userSqre.svg" alt="user"></span>
              <div class="switchInfo">
                <div class="d-flex align-center onlineStats">
                  <p>Go Online</p>
                  <div class="content contentStch">
                    <label class="switchSmall m5">
                      <input type="checkbox">
                      <small></small>
                    </label>
                  </div>
                </div>
              </div>
            </div> -->
                    <!-- <div class="usrName">
                        <div class="d-flex flex-between">
                            <div class="infoName">
                                
                                <div class="d-flex calsndInfo align-center">
                                    <span class="bgBlu">
                                        <img src="images/calendar.svg" alt="user">
                                    </span>
                                    <div class="contentDflex">
                                        <p style="text-decoration: none;">Brooks Clinic</p>
                                    </div>

                                </div><span>Anna Nagar <br />Chennai</span>
                            </div>
                            <div class="rightProfl contentDflex" style=" position: relative; bottom: 0;  right: 0;">


                                Update
                            </div>
                        </div>
                    </div> -->
                    <div class=" container-flex alert text-white col-sm ml-3" *ngIf="dcounts && dcounts?.length"
                        role="alert">
                        <div class="" *ngFor="let dam of dcounts">

                            <div class="row welcome-wrapper pe-5">
                                <div class="text-center" style="color:#2E61F2;">
                                    <h4> <i class="fa fa-hospital-o"></i><br />{{ dam.oname?dam.oname:'' }}</h4>
                                    <h5>{{ dam.address1?dam.address1+',':'' }} {{ dam.address2 ?dam.address2+',' :''}}
                                    </h5>
                                    <h5>{{ dam.city? dam.city: ''}} </h5>
                                </div>
                            </div>
                            <p>
                                <a [routerLink]="['/organisation-edit/' + dam.org_id]" class="pull-right">
                                    Update </a>
                            </p>



                        </div>
                    </div>
                </div>


                <div class="whiteBg_container flotWidth mt-3" *ngFor="let dam of dcounts">
                    <div class="d-flex flex-between" style="padding-bottom: 10px;">
                        <div class="cntntInfo">
                            <h2 style="text-align: left;">Registrations</h2>
                            <div class="d-flex flex-between">
                                <div class="d-flex flex-column countinNmbr">
                                    <label>{{dam.count }}</label>
                                    <span><a routerLink="/profile/search/physicians">Doctors</a></span>
                                </div>
                                <div class="d-flex flex-column countinNmbr">
                                    <label>{{dam.patcount }}</label>
                                    <span><a routerLink="/profile/search/patient">Patients</a></span>
                                </div>
                            </div>
                        </div>
                        <div class="colrBox yellowClr">
                            <img src="assets/images/OrangeIcon.svg" alt="user">
                        </div>

                    </div>
                    <div class="creatUsr">
                        <a href="#" [routerLink]="['/profile']">CLICK HERE TO ADD NEW PROFILE</a>
                    </div>
                </div>

                <div class="whiteBg_container flotWidth mt-3" *ngIf="users.length >0">
                    <h3 class="fontSize19">Physicians</h3>
                    <table class="table align-middle mb-0  ">

                        <tbody *ngFor="let dr of users">
                            <tr>
                                <td>
                                    <div class="d-flex align-items-center">
                                        <img src="{{dr?.ppurl}}" alt="" style="width: 45px; height: 45px"
                                            class="rounded-circle" />
                                        <div class="ms-3">
                                            <p class="fw-bold mb-1">{{ dr?.title ? dr?.title.charAt(0).toUpperCase() +
                                                dr?.title.slice(1).toLowerCase() : '' }}
                                                {{dr?.first_name}}
                                                {{dr?.last_name}} </p>
                                            <p class="text-muted mb-0">{{dr?.email_id}}</p>
                                            <p class="fw-normal mb-1">{{dr?.contact_no}}.</p>
                                        </div>

                                    </div>
                                </td>

                                <td *ngIf="dr?.consult_now=='false' || dr?.consult_now==null"
                                    style="vertical-align:middle;">
                                    <!-- <span class="badge badge-dark rounded-pill d-inline">Offline</span> -->
                                    <span class="orangedot"></span>
                                </td>
                                <td *ngIf="dr?.consult_now=='true'" style="vertical-align:middle;">
                                    <!-- <span class="badge badge-success rounded-pill d-inline">Online</span> -->
                                    <span class="greendot"></span>
                                </td>
                            </tr>
                        </tbody>

                    </table>
                </div>

                <div class="whiteBg_container flotWidth mt-3" *ngIf="fdeskusers.length >0">
                    <h3 class="fontSize19">Front Desk Executives</h3>
                    <table class="table align-middle mb-0">
                        <tbody *ngFor="let fd of fdeskusers">
                            <tr>
                                <td>
                                    <div class=" d-flex align-items-center">
                                        <img src="{{fd?.ppurl}}" alt="" style="width: 45px; height: 45px"
                                            class="rounded-circle" />
                                        <div class="ms-3">
                                            <p class="fw-bold mb-1">{{fd?.first_name}}{{fd?.last_name}}</p>
                                            <p class="text-muted mb-0">{{fd?.email_id}}</p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <p class="fw-normal mb-1">{{fd?.contact_no}}</p>

                                </td>
                            </tr>
                        </tbody>

                    </table>


                </div>

            </div>
            <div class="dashboardBox-wrapper widthAdjust60">
                <div class="row">
                    <div class="col-md-6 col-xs-12 infoBoxWrapper paddinglaftRight">
                        <div class="whiteBg_container">
                            <div class="d-flex flex-between">
                                <div class="cntntInfo">
                                    <h2 style="text-align: left;">Today’s Agenda (Online)</h2>
                                    <div class="d-flex flex-between">
                                        <div class="d-flex flex-column countinNmbr">
                                            <label>
                                                {{a_dashboardvalues?.online_admin_request_count?a_dashboardvalues.online_admin_request_count:'0'}}</label>
                                            <span><a routerLink="/appointments/request">Requests</a></span>
                                        </div>
                                        <div class="d-flex flex-column countinNmbr">
                                            <label>
                                                {{a_dashboardvalues?.online_admin_schedule_count?a_dashboardvalues.online_admin_schedule_count:'0'}}</label>
                                            <span><a routerLink="/appointment/consultation">Scheduled</a></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="colrBox">
                                    <img src="assets/images/appointment.svg" alt="user">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xs-12 infoBoxWrapper paddinglaftRight">
                        <div class="whiteBg_container">
                            <div class="d-flex flex-between">
                                <div class="cntntInfo">
                                    <h2 style="text-align: left;">Today’s Agenda (In-Person)</h2>
                                    <div class="d-flex flex-between">
                                        <div class="d-flex flex-column countinNmbr">
                                            <label>
                                                {{a_dashboardvalues?.inperson_admin_schedule_count?a_dashboardvalues.inperson_admin_schedule_count:'0'}}</label>
                                            <span><a routerLink="/appointments/Checkin">Scheduled</a></span>
                                        </div>
                                        <div class="d-flex flex-column countinNmbr">
                                            <label>{{a_dashboardvalues?.inperson_admin_checkin_count?a_dashboardvalues.inperson_admin_checkin_count:'0'}}</label>
                                            <span><a routerLink="/appointment/consultation">Check In</a></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="colrBox redClr">
                                    <img src="assets/images/medicalIcon.svg" alt="user">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-md-6 col-xs-12 infoBoxWrapper paddinglaftRight">
              <div class="whiteBg_container">
                <div class="d-flex flex-between">
                  <div class="cntntInfo">
                    <h2>Pending Appointments</h2>
                    <div class="d-flex flex-between">
                      <div class="d-flex flex-column countinNmbr">
                        <label>140</label>
                        <span>Online<a href="#">(View)</a></span>
                      </div>
                      <div class="d-flex flex-column countinNmbr">
                        <label>30</label>
                        <span>In-Person<a href="#">(View)</a></span>
                      </div>
                    </div>
                  </div>
                  <div class="colrBox orange">
                    <img src="images/pendingMedicl.svg" alt="user">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xs-12 infoBoxWrapper paddinglaftRight">
              <div class="whiteBg_container">
                <div class="d-flex flex-between">
                  <div class="cntntInfo">
                    <h2>Completed Appointments <a href="#">(View)</a></h2>
                    <div class="d-flex flex-between">
                      <div class="d-flex flex-column countinNmbr">
                        <label>174</label>
                        <span>Online</span>
                      </div>
                      <div class="d-flex flex-column countinNmbr">
                        <label>67</label>
                        <span>In-Person</span>
                      </div>
                    </div>
                  </div>
                  <div class="colrBox greenClr">
                    <img src="images/tickIcon.svg" alt="user">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xs-12 infoBoxWrapper paddinglaftRight">
              <div class="whiteBg_container">
                <div class="d-flex flex-between">
                  <div class="cntntInfo">
                    <h2>Appointment Status</h2>
                    <div class="d-flex flex-between">
                      <div class="d-flex flex-column countinNmbr">
                        <label>22</label>
                        <span>Follow up</span>
                      </div>
                      <div class="d-flex flex-column countinNmbr">
                        <label>52</label>
                        <span>Cancelled</span>
                      </div>
                    </div>
                  </div>
                  <div class="colrBox purple">
                    <img src="images/yellowIcon.svg" alt="user">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xs-12 infoBoxWrapper paddinglaftRight">
              <div class="whiteBg_container">
                <div class="d-flex flex-between">
                  <div class="cntntInfo">
                    <h2>Patients Count</h2>
                    <div class="d-flex flex-between">
                      <div class="d-flex flex-column countinNmbr">
                        <label>53</label>
                        <span>Online</span>
                      </div>
                      <div class="d-flex flex-column countinNmbr">
                        <label>38</label>
                        <span>In-person</span>
                      </div>
                    </div>
                  </div>
                  <div class="colrBox yellowClr">
                    <img src="images/OrangeIcon.svg" alt="user">
                  </div>
                </div>
              </div>
            </div> -->
                </div>
                <div class="row">
                    <div class="col-md-12 monetseTable">
                        <div class="whiteBg_container">
                            <h3 class="fontSize19">Appointments</h3>
                            <div class="table-responsive drTable">
                                <div class="chart-container">
                                    <canvas id="MyChart">{{ chart }}</canvas>
                                </div>
                            </div>
                        </div>
                        <div class="whiteBg_container mt-3">
                            <h3 class="fontSize19">Earnings</h3>
                            <div class="table-responsive drTable">
                                <div class="chart-container">
                                    <canvas id="MyChart1">{{ chart1 }}</canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>